import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notify, notifyError } from "../../../helpers/helper";
import {
  getOrders,
  updateOrder,
} from "../../../redux/action/pickups";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import { Autocomplete } from "react-materialize";

const EditOrder = ({ order }) => {
  const { organization, network } = useSelector((state) => state.organization);
  const { scraps } = useSelector((state) => state.scraps);
  const { orderLoading } = useSelector((state) => state.pickups);
  const [materials, setMaterials] = React.useState([]);
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState();
  const [chipData, setChipData] = React.useState([]);
  const [autocompleteData, setAutocompleteData] = React.useState({});
  const [autoCompleteValue, setAutoCompleteValue] = React.useState("");

  const [location, setLocation] = React.useState("");
  const dispatch = useDispatch();
  const handleAutocomplete = (value) => {
    if (chipData.includes(value)) return;
    setChipData([...chipData, value]);
    setAutoCompleteValue("");
  };

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    setStartDate(new Date(order.startDate));
    setEndDate(new Date(order.endDate));
    setLocation(order.location || "");

    order.scraps.forEach((scrap) => {
      setMaterials((prevMaterials) => [
        ...prevMaterials,
        {
          _id: scrap._id,
          quantity: scrap.quantity,
          quantityUnit: scrap.quantityUnit || "tonne",
          price: scrap.price,
        },
      ]);
    });
  }, [order]);

  useEffect(() => {
    let data = {};
    network
      .filter((nt) => nt.role === "trader/aggregator")
      .forEach((network) => {
        data[network.organization.name] = network._id;
      });
    setAutocompleteData(data);
  }, [network]);

  useEffect(() => {
    let selectedChips = [];
    order.targetedNetwork.forEach((notified) => {
      const org = network.find((nt) => nt.organization._id === notified);
      if (org) selectedChips.push(org.organization.name);
    });
    setChipData(selectedChips);

  }, [order, network]);

  function submit(e) {
    e.preventDefault();

    if (materials.some((material) => material._id === "")) {
      notifyError("Please select a material for all entries");
      return;
    }

    if (materials.some((material) => material.quantity === "")) {
      notifyError("Please enter a quantity for all entries");
      return;
    }

    if (!startDate || !endDate) {
      notifyError("Please select a valid date range");
      return;
    }

    const processedMaterials = materials.map((material) => {
      const { price, ...rest } = material;
      if (price === "" || price == null) {
        return rest;
      }
      return material;
    });

    dispatch(
      updateOrder(
        order._id,
        {
          scraps: processedMaterials,
          location,
          startDate,
          endDate,
          targetedNetwork: network
            .filter((net) => chipData.includes(net.organization.name.trim()))
            .map((net) => net.organization._id),
        },
        () => {
          dispatch(getOrders());
          notify("Success!", "Announcement updated successfully");
        }
      )
    );
  }

  return (
    <form onSubmit={submit} className="p-1">
      <p className="bold">Edit A Material Sourcing Announcement</p>

      <section className="mt-1">
        <p className="black-text bold">
          Select Date Range For This Announcement
          <span className="red-text">*</span>{" "}
        </p>
        <div className="flex hover ">
          <div
            className="flex align-center gap-1 chart-date-picker "
            style={{ height: "40px" }}
          >
            <DatePicker
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="browser-default "
              dateFormat="dd MMMM yyyy" // Format for day, month, and year
              minDate={new Date()}
            />
            <span className="material-symbols-outlined">calendar_month</span>
          </div>
        </div>
      </section>

      <div className="mt-1 ">
        <fieldset
          className="mt-1 mb-1"
          style={{ border: "1px solid #ccc", borderRadius: "5px" }}
        >
          <legend className="bold"> Material Details</legend>

          <div className="mt-1">
            <p className=",">
              Select Material, Enter quantity and Expected price:
            </p>
            <div className="flex column align-end ">
              {materials.map((material, i) => (
                <div
                  className="flex border gap-1 full-width align-center"
                  style={{
                    border: "1px solid #ccc",
                  }}
                >
                  <select
                    type="text"
                    className="browser-default"
                    style={{
                      padding: "7px 2px",
                      // borderRadius: "5px",
                      borderLeft: "none",
                      borderTop: "none",
                      borderBottom: "none",
                      borderRight: "1px solid #ccc",
                      width: "45%",
                    }}
                    placeholder="Select Material"
                    onChange={(e) => {
                      const newMaterials = [...materials];
                      newMaterials[i]._id = e.target.value;
                      setMaterials(newMaterials);
                    }}
                    min="0"
                    value={material._id}
                    required
                  >
                    <option value={""}>--select--</option>
                    {scraps?.map((scrap, i) => (
                      <option value={scrap._id} key={i}>
                        {scrap.name}-{scrap.variant}
                      </option>
                    ))}
                  </select>

                  <div
                    className="flex align-center gap-1 "
                    style={{ width: "45%", borderRight: "1px solid #ccc" }}
                  >
                    <input
                      type="text"
                      className="browser-default"
                      style={{
                        padding: "7px 2px",
                        border: "none",
                        width: "80%",
                        // borderRadius: "5px",
                        borderLeft: "none",
                        borderTop: "none",
                        borderBottom: "none",
                        borderRight: "none",
                        // borderRight: "1px solid #ccc",
                      }}
                      placeholder="Quantity in Metric Tonnes"
                      onChange={(e) => {
                        const newMaterials = [...materials];
                        newMaterials[i].quantity = e.target.value;
                        setMaterials(newMaterials);
                      }}
                      min="0.01"
                      value={material.quantity}
                      required
                    />
                    <p className="small-text">MT</p>
                  </div>
                  <div
                    className="flex align-center gap-1 "
                    style={{ width: "45%", borderRight: "1px solid #ccc" }}
                  >
                    <input
                      type="text"
                      className="browser-default"
                      style={{
                        padding: "7px 2px",
                        border: "none",
                        width: "80%",
                        // borderRadius: "5px",
                        borderLeft: "none",
                        borderTop: "none",
                        borderBottom: "none",
                        borderRight: "none",
                        // borderRight: "1px solid #ccc",
                      }}
                      placeholder="Price in INR/KG"
                      onChange={(e) => {
                        const newMaterials = [...materials];
                        newMaterials[i].price = e.target.value;
                        setMaterials(newMaterials);
                      }}
                      min="0.01"
                      value={material.price}
                    />
                    <p className="small-text">
                      <span className="bold">₹</span> /kg
                    </p>
                  </div>

                  {materials.length > 1 && (
                    <span
                      class="material-symbols-outlined grey-text pointer"
                      onClick={() => {
                        const newMaterials = [...materials];
                        newMaterials.splice(i, 1);
                        setMaterials(newMaterials);
                      }}
                    >
                      cancel
                    </span>
                  )}
                </div>
              ))}

              <button
                className="btn-small mt-1"
                type="button"
                onClick={() => {
                  setMaterials([
                    ...materials,
                    {
                      _id: "",
                      quantity: "",
                      quantityUnit: "tonne",
                      price: "",
                    },
                  ]);
                }}
              >
                Add another Material
              </button>
            </div>
          </div>
        </fieldset>
      </div>

      <div className="mt-1">
        <p className="black-text">
          Select Location you're sourcing for
          <span className="red-text">*</span>{" "}
        </p>
        <div className="row  ">
          <select
            className="input-style full-width browser-default "
            name="location"
            onChange={(e) => setLocation(e.target.value)}
            value={location}
            required
          >
            <option value={""}>--select--</option>
            {organization.locations?.map((loc, i) => (
              <option value={loc._id} key={i}>
                {loc.nickname}-{loc.address}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* <div className="mt-1">
        <p className="black-text">
          Select Target Audience for this Announcement
          <span className="red-text">*</span>{" "}
        </p>
        <div className="row  ">
          <select
            className="input-style full-width browser-default "
            name="location"
            onChange={(e) => setTarget(e.target.value)}
            value={target}
            required
          >
            <option value="all-network">All Network</option>
            <option value="individual-selection">Custom Select</option>
          </select>
        </div>
      </div> */}

      <div className="mt-1">
        <p className="black-text">
          Select all the traders to be notified for this Announcement
          <span className="red-text">*</span>{" "}
        </p>

        <Autocomplete
          options={{
            data: autocompleteData,
            onAutocomplete: (value) => handleAutocomplete(value),
          }}
          className="browser-default full-width input-style"
          placeholder="Enter trader name..."
          value={autoCompleteValue}
          onChange={(e) => setAutoCompleteValue(e.target.value)}
        />

        {chipData.map((chip, index) => (
          <div className="chip">
            {chip}
            <i
              className="close material-icons"
              onClick={() =>
                setChipData(chipData.filter((chip) => chip !== chipData[index]))
              }
            >
              close
            </i>
          </div>
        ))}
      </div>

      <div className="mt-1 flex gap-1">
        <button className="btn waves-effect waves-purple" type="submit">
          {orderLoading ? (
            <ClipLoader color={"white"} size={20} />
          ) : (
            "Update Announcement"
          )}
        </button>
        <button
          className="btn white cercle-purple-text waves-effect waves-purple"
          onClick={() => {
            setMaterials([
              {
                _id: "",
                quantity: "",
                quantityUnit: "tonne",
                price: "",
              },
            ]);
          }}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default EditOrder;
